var accordionTitleStyles = {
  root: function root() {
    return {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '.5rem 0',
      cursor: 'pointer'
    };
  },
  indicator: function indicator() {
    return {
      userSelect: 'none'
    };
  }
};
export default accordionTitleStyles;